export const WELFARE_REQUEST_TYPES = [
  'medical',
  'bereavement',
  'school_fees',
  'rent',
  'food',
  'emergency',
  'other',
] as const;

export type WelfareRequestType = (typeof WELFARE_REQUEST_TYPES)[number];

export const WELFARE_STATUSES = [
  'submitted',
  'under_review',
  'approved',
  'rejected',
  'disbursed',
  'voided',
] as const;

export type WelfareStatus = (typeof WELFARE_STATUSES)[number];

export interface WelfareRequest {
  id: string;
  churchId: string;
  memberId: string;
  memberName: string;
  requestType: string;
  description: string;
  requestedAmountMinor: number;
  approvedAmountMinor: number | null;
  approvedAmountOverrideReason: string | null;
  currency: string;
  status: WelfareStatus;
  reviewedBy: string | null;
  approvedBy: string | null;
  disbursedAt: string | null;
  disbursementExpenseId: string | null;
  voidReason: string | null;
  notesAvailable: boolean;
  confidentialNotes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const welfareStepperIndex = (status: WelfareStatus): number => {
  switch (status) {
    case 'submitted':
      return 0;
    case 'under_review':
      return 1;
    case 'approved':
    case 'rejected':
      return 2;
    case 'disbursed':
    case 'voided':
      return 3;
    default:
      return 0;
  }
};
